import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {SessionStorageService} from './session-storage/session-storage.service';
import {AuthenticationService} from './authentication/authentication.service';


@Injectable()
export class HttpLogado {

  constructor(private http: HttpClient, private sessionService :SessionStorageService,private auth:AuthenticationService ) {}

  getAuthorizationHeader() {
    if((parseInt(this.sessionService.getItem('expireIn'))-15*60*1000) <= (new Date().getTime())){
      this.auth.renew()
    }
    return {Authorization: 'Bearer ' + window.sessionStorage.getItem('token')};
  }

  get(url) {
    return this.http.get(url, {
      headers: this.getAuthorizationHeader()
    });
  }

  post(url, data) {
    return this.http.post(url, data, {
      headers: this.getAuthorizationHeader()
    });
  }
  put(url, data) {
    return this.http.put(url, data, {
      headers: this.getAuthorizationHeader()
    });
  }
  patch(url, data) {
    return this.http.patch(url, data, {
      headers: this.getAuthorizationHeader()
    });
  }
  delete(url) {
    return this.http.delete(url, {
      headers: this.getAuthorizationHeader()
    });
  }
}
